<div *ngIf="updatedStaus || updateNeeded">
  <div class="ct-overlay">
    <div class="ct-modal">
      <img class="cm-icon" src="assets/icons/app-refresh.svg" alt="" />
      <p class="cm-msg-one">{{ "NewUpdateIsAvailable" | translate }}</p>
      <p class="cm-msg-two">
        {{ "ToEnjoyOurNewestFeaturesTapTheButtonBelow" | translate }}
      </p>
      <div class="cm-btn-grp">
        <button class="cm-btn-dark" (click)="onRefreshClick()">
          {{ "Refresh" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
